import styled from "styled-components"

const InputTitle = styled.div`
  display: flex;
  flex-direction: row;
  height: 21px;
  font-family: ${props => props.theme.fonts.avenirNextMedium};
  font-size: 0.9375rem;
  align-items: center;
`

export default InputTitle
